import { SVGProps } from "react";

const TimeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="currentColor"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1411_6266)">
        <path
          d="M6.39246 12.7699C0.915886 12.7644 -1.83881 6.11341 2.02982 2.23743C4.32634 -0.155788 8.45863 -0.156174 10.7551 2.23752C14.6237 6.11384 11.8687 12.7647 6.39246 12.7699ZM6.39246 1.39439C3.52201 1.39439 1.18673 3.72966 1.18673 6.60012C1.47268 13.5062 11.3133 13.5042 11.5982 6.60007C11.5982 3.72969 9.26289 1.39439 6.39246 1.39439ZM8.63724 8.16324L7.11437 6.64037C7.12777 6.41546 7.03185 6.20051 6.87423 6.06101C6.87438 6.05597 6.87447 6.05091 6.87447 6.04583V3.22606C6.84902 2.58652 5.93568 2.58701 5.91045 3.22606V6.04583C5.91045 6.05091 5.91054 6.05597 5.91069 6.06101C5.40662 6.51222 5.74856 7.35729 6.43268 7.32205L7.95555 8.84492C8.14378 9.03317 8.44899 9.03317 8.63721 8.84492C8.82546 8.65667 8.82546 8.35149 8.63724 8.16324Z"
          // fill="#3F3F46"
        />
      </g>
      <defs>
        <clipPath id="clip0_1411_6266">
          <rect
            width="12.3395"
            height="12.3395"
            fill="white"
            transform="translate(0.222656 0.438477)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TimeIcon;
